import { z } from 'zod';

/** 一覧の「1ページあたり件数」候補。pageSize の上限もこの最大値に合わせる。 */
export const PAYROLL_ITEM_PAGE_SIZE_OPTIONS = [25, 50, 100, 200, 300] as const;
const DEFAULT_PAGE_SIZE = 50;
const MAX_PAGE_SIZE = Math.max(...PAYROLL_ITEM_PAGE_SIZE_OPTIONS);

/**
 * Payroll items 一覧専用 search。
 *
 * 絞り込みは 2 軸に分かれる。`categoryTab` が side panel の帳簿上の分類
 * （支給 / 控除 / 集計 / …）、`lifecycleTab` が一覧上部のステータスタブ
 * （適用中 / 適用予定 / 下書き / すべて / アーカイブ）。
 * ステータスは structure / unit 一覧と同じキーで、`lifecycleTab` という
 * 名前も `EngineAtomListFilterSection` の props に合わせている。
 *
 * pageIndex / pageSize は URL 直打ちでも壊れないよう `catch` で既定値へ落とす。
 * 総件数に対する上限の丸めは総件数を知る API 側（`resolvePageSlice`）が担当する。
 */
export const PayrollItemListSearchSchema = z.object({
  categoryTab: z.enum(['earnings', 'deductions', 'aggregates', 'adjustments', 'employerContributions', 'reimbursements', 'paymentsInKind', 'references']).catch('earnings'),
  /** ステータスタブ。structure / unit 一覧と同じキー集合。 */
  lifecycleTab: z.enum(['all', 'draft', 'applied', 'archived', 'scheduled']).catch('applied'),
  countryCode: z.string().catch('all'),
  /** 名称・コード・説明に対するフリーテキスト絞り込み。 */
  freeText: z.string().catch(''),
  /** 管理タグ絞り込み（いずれかのタグを含む項目に一致）。 */
  managementTags: z.array(z.string()).catch([]),
  pageIndex: z.number().int().min(0).catch(0),
  pageSize: z.number().int().min(1).max(MAX_PAGE_SIZE).catch(DEFAULT_PAGE_SIZE)
});
export type PayrollItemListSearchParams = z.infer<typeof PayrollItemListSearchSchema>;